import React from "react";

function Button({ type = 'button', content, onClick }) {
    return (
        <>
            <button type={type} className="btn btn-lg submit-btn" onClick={onClick}> {content} </button>
        </>
    )
}

export default Button;